import { lazyLoad } from 'utils/loadable';

export const WorkExperienceGridLoadable = lazyLoad(
  () => import('./WorkExperienceGrid'),
  module => module.WorkExperienceGrid,
);
